import * as cx from 'classnames';
import {
    getInlinedImages,
    linebreaksbr,
    mentionize,
    replaceImageMarks,
    upperCaseFirst,
    urlize,
} from 'mk/bazaar/common/filters';
import { ArticleEntity, ExperienceEntity } from 'mk2/apps/wiki/schemas';
import Emojify from 'mk2/components/Emojify';
import StarsRating from 'mk2/components/StarsRating';
import * as React from 'react';
import styles from './ExperienceBody.mscss'; // tslint:disable-line

interface OwnProps {
    experience: ExperienceEntity;
    article: ArticleEntity;
}

type Props = OwnProps;

export default class ExperienceBody extends React.Component<Props> {

    public render() {
        const {
            experience, article,
        } = this.props;

        // prepare experience message body
        let bodyChunks: React.ReactChild[] = [experience.text];
        bodyChunks = linebreaksbr(upperCaseFirst(mentionize(urlize(bodyChunks, 50))));

        return (
            <div className={styles.ExperienceBody}>
                {experience.title &&
                    <h1 className={styles.ExperienceBody__title}>
                        <Emojify>
                            {upperCaseFirst(experience.title)}
                        </Emojify>
                    </h1>
                }
                <div className={styles.ExperienceBody__text}>
                    <Emojify size={17}>
                        {bodyChunks}
                    </Emojify>
                </div>

                {experience.starsCount > 0 && article.experiencesStarsAllowed &&
                    <StarsRating
                        starsCount={experience.starsCount}
                        className={styles.ExperienceBody__starsRating}
                    />}
                {article.experiencesPositivesNegativesAllowed && experience.positives && experience.positives.length > 0 && (
                        <ul className={styles.ExperienceBody__positivesList}>
                            {experience.positives.map(
                            (point, index) => {
                                return(
                                    <li className={styles.ExperienceBody__positivesList__listItem} key={index}>
                                        <i className={cx('fa fa-plus-circle', styles.ExperienceBody__positivesList__listItem__icon)} />
                                        {point}
                                    </li>
                                );
                            },
                            )}
                        </ul>
                    )}
                {article.experiencesPositivesNegativesAllowed && experience.negatives && experience.negatives.length > 0 && (
                        <ul className={styles.ExperienceBody__negativesList}>
                            { experience.negatives.map(
                            (point, index) => {
                                return(
                                    <li className={styles.ExperienceBody__negativesList__listItem} key={index}>
                                        <i className={cx('fa fa-minus-circle', styles.ExperienceBody__negativesList__listItem__icon)} />
                                        {point}
                                    </li>
                                );
                            },
                            )}
                        </ul>
                    )}
            </div>
        );
    }
}
